// @flow
import * as React from 'react';
import {
    Box, Button, TextInput,
} from 'grommet';
import { Next, Previous } from 'grommet-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

type Props = {
    offset: number,
    pageSize: number,
    count: number,
    onPageChange: (page: number) => void,
    onPageSizeChange: (pageSize: number) => void,
}

class Pagination extends React.Component<Props> {
    static defaultProps = {
        pageSize: 10,
    };

    constructor(props: Props) {
        super(props);

        this.pageInput = React.createRef();
    }

    getPagination = () => {
        const { count, pageSize, offset } = this.props;

        return {
            pages: Math.ceil((count / pageSize) || 1),
            currentPage: ((offset / pageSize) || 0) + 1,
        };
    };

    handlePageSizeChange = (e: SyntheticInputEvent<HTMLInputElement>) => {
        if (!e.target.value || e.target.value < 1) {
            e.target.value = 1;
        }

        this.props.onPageSizeChange(e.target.value);
    };

    handlePageChange = (e: SyntheticInputEvent<HTMLInputElement>) => {
        const { pages } = this.getPagination();

        if (!e.target.value || e.target.value < 1) {
            e.target.value = 1;
        }

        if (e.target.value >= pages) {
            e.target.value = pages;
        }

        this.props.onPageChange(e.target.value - 1);
    };

    handleNextPageChange = (event: SyntheticMouseEvent<HTMLButtonElementT>) => {
        const newPage = this.getPagination().currentPage;

        this.pageInput.current.value = newPage + 1;

        this.props.onPageChange(newPage);
    };

    handlePrevPageChange = (event: SyntheticMouseEvent<HTMLButtonElementT>) => {
        const newPage = this.getPagination().currentPage - 2;

        this.pageInput.current.value = newPage + 1;

        this.props.onPageChange(newPage);
    };

    render(): React.ReactNode {
        const { pageSize } = this.props;
        const page = this.getPagination();
        const StyledDiv = styled.div`
             display: inline-flex;
             align-items: center;
             margin: 0 auto;
             flex-wrap: wrap;
             justify-content: center;
        `;

        return (
            <Box direction="row" justify="between" alignSelf="center" alignContent="center">
                <Box direction="row">
                    <Box pad="small">
                        <Button
                            disabled={page.currentPage === 1}
                            icon={<Previous align="center" />}
                            plain={false}
                            onClick={this.handlePrevPageChange}
                            size="small"
                        />
                    </Box>
                    <StyledDiv>
                        <Box direction="row" pad="small">
                            <span style={{ fontWeight: 'bold', paddingTop: '4px' }}>
                                <FormattedMessage id="pagination-page" defaultMessage="Page" />
                            </span>
                            <TextInput
                                type="number"
                                min="1"
                                defaultValue={page.currentPage}
                                onBlur={this.handlePageChange}
                                ref={this.pageInput}
                                size="small"
                                style={{ margin: '0px 6px' }}
                            />
                        </Box>
                        <Box direction="row">
                            <span style={{ fontWeight: 'bold' }}>
                                <FormattedMessage id="pagination-of" defaultMessage="of" />
                            </span>
                            <span style={{ fontWeight: 'bold', marginLeft: '4px' }}>
                                {' '}
                                {page.pages}
                                {' '}
                            </span>
                        </Box>
                        <Box direction="row" pad="small">
                            <TextInput
                                type="number"
                                min="1"
                                defaultValue={pageSize}
                                onBlur={this.handlePageSizeChange}
                                size="small"
                                style={{ margin: '0px 6px' }}
                            />
                            <span
                                style={{ fontWeight: 'bold', paddingTop: '4px' }}
                            >
                                <FormattedMessage id="pagination-rows" defaultMessage="Rows" />
                            </span>
                        </Box>
                    </StyledDiv>
                    <Box pad="small">
                        <Button
                            disabled={page.currentPage >= page.pages}
                            icon={<Next />}
                            plain={false}
                            onClick={this.handleNextPageChange}
                            size="small"
                        />
                    </Box>
                </Box>
            </Box>
        );
    }
}

export default Pagination;
